export function InsertLink (pEditor, pLink)
{
  this.queryOpenInsertLinkDialogEnabled = (pButton, command) =>
  {
    let currentSelection = pEditor.range.selection.getCurrent(),
        currentRange = pEditor.range.getCurrent(),
        currentRangeHTML,
        currentRangeStart,
        currentRangeEnd,
        parentCurrentElement,
        childElementsA,
        attParams,
        startParentBlockElement,
        endParentBlockElement,
        cleanedLocationHref,
        cleanedIFrameHref,
        cleanedLinkHref,
        iFrameLocationHref = pEditor.iFrame.location.href.toLowerCase(),
        checkParentTagA = /^a$/i,
        checkFirstBlockTags = /^<(body|p|h[1-6]|div|pre|li|blockquote|center|dt|dd|td|th|address|marquee)(\s|>)/i,
        checkInnerBlockTags = /^.+?<(body|p|h[1-6]|div|pre|li|blockquote|center|dt|dd|td|th|address|marquee)(\s|>)/i,
        checkTagA = /<a(\s|>)/ig,
        checkMoreThanA = /([^<]+<a(\s|>)|<\/a>.+)/i,
        ret = false;

    if (BEditor.browser.isIE)
    {
      if (currentSelection.type.toUpperCase() === 'NONE' || (currentSelection.type.toUpperCase() === 'CONTROL' && currentRange.length === 1 && currentRange.item(0).nodeName.toUpperCase() === 'IMG'))
      {
        parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

        if (parentCurrentElement)
        {
          attParams = pButton.getAttribute('parameters');

          if (attParams)
          {
            checkLinkType(parentCurrentElement.href.toLowerCase());
          }
        }
        else
        {
          ret = true;
        }
      }
      else if (currentSelection.type.toUpperCase() === 'CONTROL' && currentRange.length === 1 && currentRange.item(0).nodeName.toUpperCase() === 'A')
      {
        attParams = pButton.getAttribute('parameters');

        if (attParams)
        {
          checkLinkType(currentRange.item(0).href.toLowerCase());
        }
        else
        {
          ret = true;
        }
      }
      else if (currentSelection.type.toUpperCase() !== 'CONTROL')
      {
        currentRangeHTML = currentRange.htmlText.replace(/[\r\n]/g, '');
        checkFirstBlockTags.lastIndex = 0;

        if (checkFirstBlockTags.test(currentRangeHTML))
        {
          currentRangeStart = currentRange.duplicate();
          currentRangeStart.collapse(true);
          currentRangeEnd = currentRange.duplicate();
          currentRangeEnd.collapse(false);
          startParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeStart, pEditor.checkAllBlockTags);
          endParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeEnd, pEditor.checkAllBlockTags);

          if (startParentBlockElement === endParentBlockElement)
          {
            parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, pEditor.checkAllBlockTags);
            childElementsA = parentCurrentElement.getElementsByTagName('A');

            if (childElementsA.length === 1)
            {
              attParams = pButton.getAttribute('parameters');

              if (attParams)
              {
                checkLinkType(childElementsA[0].href.toLowerCase());
              }
            }
            else if (childElementsA.length === 0)
            {
              ret = true;
            }
          }
        }
        else
        {
          checkInnerBlockTags.lastIndex = 0;
          checkTagA.lastIndex = 0;
          checkMoreThanA.lastIndex = 0;

          if (!checkInnerBlockTags.test(currentRangeHTML) && !(checkTagA.test(currentRangeHTML) && checkTagA.test(currentRangeHTML)) && !checkMoreThanA.test(currentRangeHTML))
          {
            currentRangeStart = currentRange.duplicate();
            currentRangeEnd = currentRange.duplicate();

            if (currentRangeStart && currentRangeEnd)
            {
              currentRangeStart.moveStart('character', 1);
              currentRangeStart.moveStart('character', -1);
              currentRangeStart.collapse(true);
              currentRangeEnd.collapse(false);

              startParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeStart, pEditor.checkAllBlockTagsPlusA);
              endParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeEnd, pEditor.checkAllBlockTagsPlusA);

              if (startParentBlockElement === endParentBlockElement)
              {
                parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

                if (parentCurrentElement)
                {
                  attParams = pButton.getAttribute('parameters');

                  if (attParams)
                  {
                    checkLinkType(parentCurrentElement.href.toLowerCase());
                  }
                }
                else
                {
                  ret = true;
                }
              }
            }
          }
        }
      }
    }
    else
    {
      if (currentRange.collapsed)
      {
        ret = true;

        parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

        if (parentCurrentElement)
        {
          attParams = pButton.getAttribute('parameters');

          if (attParams)
          {
            checkLinkType(parentCurrentElement.href.toLowerCase());
          }
        }
      }
      else
      {
        startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkAllBlockTagsPlusA);
        endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkAllBlockTagsPlusA);

        if (startParentBlockElement === endParentBlockElement)
        {
          ret = true;

          if (currentRange.endOffset - currentRange.startOffset < 2 && currentRange.startContainer.hasChildNodes())
          {
            if (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() === 'A')
            {
              parentCurrentElement = currentRange.startContainer.childNodes[currentRange.startOffset];
              attParams = pButton.getAttribute('parameters');

              if (attParams)
              {
                checkLinkType(parentCurrentElement.href.toLowerCase());
              }
            }
            else if (currentRange.startContainer.childNodes[currentRange.startOffset].nodeName.toUpperCase() === 'IMG')
            {
              parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

              if (parentCurrentElement)
              {
                attParams = pButton.getAttribute('parameters');

                if (attParams)
                {
                  checkLinkType(parentCurrentElement.href.toLowerCase());
                }
              }
            }
            else
            {
              ret = false;
            }
          }
          else
          {
            parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

            if (parentCurrentElement)
            {
              attParams = pButton.getAttribute('parameters');

              if (attParams)
              {
                checkLinkType(parentCurrentElement.href.toLowerCase());
              }
            }
          }
        }
      }
    }

    return ret;

    function checkLinkType (href)
    {
      cleanedLocationHref = pEditor.helpers.winLocationHref.toLowerCase().replace(/\#.*?$/, '');
      cleanedIFrameHref = iFrameLocationHref.toLowerCase().replace(/\#.*?$/, '');
      cleanedLinkHref = href.replace(/(?:^\/\#|\#).*?$/, '');

      if (BEditor.browser.isIE)
      {
        if (command === 'openInsertLinkDialog' && attParams.excludeStrings)
        {
          if ((href.indexOf('#') === -1 || (cleanedLinkHref.trim() && cleanedLinkHref !== cleanedIFrameHref && cleanedLinkHref !== cleanedLocationHref)))
          {
            ret = true;
          }
        }
        else if (command === 'openInsertDocumentDialog' && attParams.includeStrings)
        {
          if ((href.indexOf('#') === -1 || (cleanedLinkHref.trim() && cleanedLinkHref !== cleanedIFrameHref && cleanedLinkHref !== cleanedLocationHref)) &&
            href.indexOf(attParams.includeStrings[0].toLowerCase()) !== -1 ||
            href.indexOf(attParams.includeStrings[1].toLowerCase()) !== -1 ||
            href.indexOf(attParams.includeStrings[2].toLowerCase()) !== -1)
          {
            ret = true;
          }
        }
        else if (command === 'openInsertLinkToAnchorDialog')
        {
          if (href.indexOf('#') !== -1 && (!window.EditorToolbarComposeEmailConfig || pEditor.pToolbarConfig.name !== EditorToolbarComposeEmailConfig.name) &&
            (!cleanedLinkHref.trim() || cleanedLocationHref === cleanedLinkHref || cleanedLinkHref === cleanedIFrameHref))
          {
            ret = true;
          }
        }
        else
        {
          ret = true;
        }
      }
      else
      {
        if (command === 'openInsertLinkDialog' && attParams.excludeStrings)
        {
          if ((href.indexOf('#') !== -1 && (!window.EditorToolbarComposeEmailConfig || pEditor.pToolbarConfig.name !== EditorToolbarComposeEmailConfig.name) &&
            (!cleanedLinkHref.trim() || cleanedLinkHref === cleanedIFrameHref || cleanedLinkHref === cleanedLocationHref)))
          {
            ret = false;
          }
        }
        else if (command === 'openInsertDocumentDialog' && attParams.includeStrings)
        {
          if ((href.indexOf('#') !== -1 && (!window.EditorToolbarComposeEmailConfig || pEditor.pToolbarConfig.name !== EditorToolbarComposeEmailConfig.name) &&
            (!cleanedLinkHref.trim() || cleanedLinkHref === cleanedIFrameHref || cleanedLinkHref === cleanedLocationHref)) ||
            (href.indexOf(attParams.includeStrings[0].toLowerCase()) === -1 &&
              href.indexOf(attParams.includeStrings[1].toLowerCase()) === -1 &&
              href.indexOf(attParams.includeStrings[2].toLowerCase()) === -1))
          {
            ret = false;
          }
        }
        else if (command === 'openInsertLinkToAnchorDialog')
        {
          if (href.indexOf('#') === -1 || (cleanedLinkHref.trim() && cleanedLinkHref !== cleanedIFrameHref && cleanedLinkHref !== cleanedLocationHref))
          {
            ret = false;
          }
        }
      }
    }
  };


  function prepareInsertLinkDialog (pButton)
  {
    let currentSelection = pEditor.range.selection.getCurrent(),
        currentRange = pEditor.range.getCurrent(),
        currentRangeStart,
        currentRangeEnd,
        currentRangeHTML,
        currentRangeText,
        currentElement,
        parentCurrentElement,
        childElementsA,
        startParentBlockElement,
        endParentBlockElement,
        rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute(),
        domHelperElement,
        checkParentTagA = /^a$/i,
        checkFirstBlockTags = /^<(body|p|h[1-6]|div|pre|li|blockquote|center|dt|dd|td|th|address|marquee)(\s|>)/i,
        ret = false;

    let rpTitle = '',
        rpImageLink = '',
        rpImageWidth = '',
        rpImageHeight = '',
        rpImageBorder = '',
        rpImageAlign = '',
        rpImageTitle = '',
        rpImageAlt = '',
        rpImageStyle = '',
        rpLink = '',
        rpTooltip = '',
        rpClassName = '',
        rpIsStyleLink = false,
        rpOpenInNewWindow = true,
        rpCurrentPageId = 0,
        rpCurrentEventId = 0;

    if (pEditor.extParameters && pEditor.extParameters.currentPageId)
    {
      rpCurrentPageId = pEditor.extParameters.currentPageId;
    }

    if (pEditor.extParameters && pEditor.extParameters.currentEventId)
    {
      rpCurrentEventId = pEditor.extParameters.currentEventId;
    }

    if (BEditor.browser.isIE)
    {
      pEditor.image.currentImage = pEditor.image.getCurrentImage() || pEditor.image.currentImage;

      if (pEditor.image.currentImage)
      {
        rpImageLink = pEditor.image.currentImage.src;
        rpImageWidth = pEditor.image.currentImage.width;
        rpImageHeight = pEditor.image.currentImage.height;
        rpImageBorder = pEditor.image.currentImage.border;
        rpImageAlign = pEditor.image.currentImage.align;
        rpImageTitle = pEditor.image.currentImage.title;
        rpImageAlt = pEditor.image.currentImage.alt;
        rpImageStyle = pEditor.image.currentImage.style.cssText;

        parentCurrentElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(pEditor.image.currentImage, checkParentTagA, pEditor.checkAllBlockTags);

        if (parentCurrentElement && parentCurrentElement.nodeName && parentCurrentElement.nodeName.toUpperCase() === 'A')
        {
          currentRange = pEditor.iFrameDoc.body.createTextRange();
          currentRange.moveToElementText(parentCurrentElement);
          currentRange.select();

          rpLink = (parentCurrentElement.href != null) ? parentCurrentElement.href : '';
          rpTooltip = (parentCurrentElement.title != null) ? parentCurrentElement.title : '';
          rpClassName = (parentCurrentElement.className != null) ? parentCurrentElement.className : '';
          rpOpenInNewWindow = (parentCurrentElement.target.toLowerCase() === '_blank');
        }

        ret = true;
      }
      else if (currentSelection.type.toUpperCase() === 'CONTROL' && currentRange.length === 1 && currentRange.item(0).nodeName.toUpperCase() === 'A')
      {
        rpLink = (currentRange.item(0).href != null) ? currentRange.item(0).href : '';
        rpTitle = (currentRange.item(0).innerHTML != null) ? currentRange.item(0).innerHTML : '';
        rpTooltip = (currentRange.item(0).title != null) ? currentRange.item(0).title : '';
        rpClassName = (currentRange.item(0).className != null) ? currentRange.item(0).className : '';
        rpOpenInNewWindow = (currentRange.item(0).target.toLowerCase() === '_blank');
        rpIsStyleLink = true;

        ret = true;
      }
      else if (currentSelection.type.toUpperCase() !== 'CONTROL')
      {
        currentRangeHTML = currentRange.htmlText.replace(/[\r\n]/g, '');
        checkFirstBlockTags.lastIndex = 0;

        if (checkFirstBlockTags.test(currentRangeHTML))
        {
          currentRangeStart = currentRange.duplicate();
          currentRangeStart.collapse(true);
          currentRangeEnd = currentRange.duplicate();
          currentRangeEnd.collapse(false);
          startParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeStart, pEditor.checkAllBlockTags);
          endParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeEnd, pEditor.checkAllBlockTags);

          if (startParentBlockElement === endParentBlockElement)
          {
            parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, pEditor.checkAllBlockTags);
            childElementsA = parentCurrentElement.getElementsByTagName('A');

            if (childElementsA.length === 1)
            {
              currentRange.moveToElementText(childElementsA[0]);

              if (!pEditor.isEditorInHeader || !rangeElement || rangeElement.nodeName.toUpperCase() === 'IMG')
              {
                currentRange.select();
              }

              rpTitle = childElementsA[0].innerHTML;
              rpLink = (childElementsA[0].href) ? childElementsA[0].href : '';
              rpTooltip = (childElementsA[0].title) ? childElementsA[0].title : '';
              rpClassName = (childElementsA[0].className) ? childElementsA[0].className : '';
              rpOpenInNewWindow = (childElementsA[0].target === '_blank');

              ret = true;
            }
            else if (childElementsA.length === 0)
            {
              currentRangeText = parentCurrentElement.innerText;

              if (currentRangeText)
              {
                rpTitle = parentCurrentElement.innerHTML;
              }
              else
              {
                rpTitle = '';
              }

              ret = true;
            }
          }
        }
        else
        {
          currentRangeStart = currentRange.duplicate();
          currentRangeEnd = currentRange.duplicate();

          if (currentRangeStart && currentRangeEnd)
          {

            currentRangeStart.moveStart('character', 1);
            currentRangeStart.moveStart('character', -1);
            currentRangeStart.collapse(true);
            currentRangeEnd.collapse(false);

            startParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeStart, pEditor.checkAllBlockTagsPlusA);
            endParentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeEnd, pEditor.checkAllBlockTagsPlusA);

            if (currentSelection.type.toUpperCase() === 'NONE' || startParentBlockElement === endParentBlockElement)
            {
              parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRangeStart, checkParentTagA, pEditor.checkAllBlockTags);

              if (parentCurrentElement)
              {
                currentRange.moveToElementText(parentCurrentElement);

                if (pEditor.isEditorInHeader && (!rangeElement || rangeElement.nodeName.toUpperCase() === 'IMG'))
                {
                  currentRange.select();
                }

                rpTitle = parentCurrentElement.innerHTML;
                rpLink = (parentCurrentElement.href) ? parentCurrentElement.href : '';
                rpTooltip = (parentCurrentElement.title) ? parentCurrentElement.title : '';
                rpClassName = (parentCurrentElement.className) ? parentCurrentElement.className : '';
                rpOpenInNewWindow = (parentCurrentElement.target === '_blank');

                ret = true;
              }
              else
              {
                rpTitle = currentRange.htmlText;
                ret = true;
              }
            }
          }
        }
      }
    }
    else
    {
      pEditor.image.currentImage = pEditor.image.getCurrentImage();

      startParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.startContainer, pEditor.checkAllBlockTagsPlusA);
      endParentBlockElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(currentRange.endContainer, pEditor.checkAllBlockTagsPlusA);

      if (startParentBlockElement === endParentBlockElement)
      {
        if (pEditor.image.currentImage)
        {
          rpImageLink = pEditor.image.currentImage.getAttribute('src');
          rpImageWidth = pEditor.image.currentImage.getAttribute('width');
          rpImageHeight = pEditor.image.currentImage.getAttribute('height');
          rpImageBorder = pEditor.image.currentImage.getAttribute('border');
          rpImageAlign = pEditor.image.currentImage.getAttribute('align');
          rpImageTitle = pEditor.image.currentImage.getAttribute('title');
          rpImageAlt = pEditor.image.currentImage.getAttribute('alt');
          rpImageStyle = pEditor.image.currentImage.getAttribute('style');

          parentCurrentElement = pEditor.helpers.element.getParentElementFromElementByTagsNames(pEditor.image.currentImage, checkParentTagA, pEditor.checkAllBlockTags);

          if (parentCurrentElement)
          {
            currentSelection.removeAllRanges();
            currentRange = pEditor.iFrameDoc.createRange();
            currentRange.selectNode(parentCurrentElement);
            currentSelection.addRange(currentRange);

            rpLink = (parentCurrentElement.href) ? parentCurrentElement.href : '';
            rpTooltip = (parentCurrentElement.title) ? parentCurrentElement.title : '';
            rpClassName = (parentCurrentElement.className) ? parentCurrentElement.className : '';
            rpOpenInNewWindow = (parentCurrentElement.target === '_blank');
          }

          ret = true;
        }
        else
        {
          parentCurrentElement = currentRange.startContainer;

          if (parentCurrentElement.hasChildNodes())
          {
            currentElement = parentCurrentElement.childNodes[currentRange.startOffset];

            if (currentElement && currentElement.nodeName.toUpperCase() === 'A')
            {
              currentSelection.removeAllRanges();
              currentRange = pEditor.iFrameDoc.createRange();
              currentRange.selectNode(currentElement);
              currentSelection.addRange(currentRange);

              rpTitle = currentElement.innerHTML;
              rpLink = (currentElement.href) ? currentElement.href : '';
              rpTooltip = (currentElement.title) ? currentElement.title : '';
              rpClassName = (currentElement.className) ? currentElement.className : '';
              rpOpenInNewWindow = (currentElement.target === '_blank');

              ret = true;
            }
            else if (currentRange.endOffset - currentRange.startOffset < 2)
            {
              if (currentRange.collapsed)
              {
                ret = true;
              }
              else
              {
                ret = null;
              }
            }
          }
        }

        if (!ret && ret != null)
        {
          parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

          if (parentCurrentElement)
          {
            currentSelection.removeAllRanges();
            currentRange = pEditor.iFrameDoc.createRange();
            currentRange.selectNode(parentCurrentElement);
            currentSelection.addRange(currentRange);

            rpTitle = parentCurrentElement.innerHTML;
            rpLink = (parentCurrentElement.href) ? parentCurrentElement.href : '';
            rpTooltip = (parentCurrentElement.title) ? parentCurrentElement.title : '';
            rpClassName = (parentCurrentElement.className) ? parentCurrentElement.className : '';
            rpOpenInNewWindow = (parentCurrentElement.target === '_blank');
          }
          else
          {
            domHelperElement = pEditor.iFrameDoc.createElement('DIV');
            domHelperElement.appendChild(currentRange.cloneContents());

            rpTitle = domHelperElement.innerHTML;
          }

          ret = true;
        }
      }
    }

    return(
    {
      isCommandValid: ret,
      title: rpTitle,
      imageLink: rpImageLink,
      imageWidth: rpImageWidth,
      imageHeight: rpImageHeight,
      imageBorder: rpImageBorder,
      imageAlign: rpImageAlign,
      imageTitle: rpImageTitle,
      imageAlt: rpImageAlt,
      imageStyle: rpImageStyle,
      link: rpLink,
      tooltip: rpTooltip,
      className: rpClassName,
      isStyleLink: rpIsStyleLink,
      openInNewWindow: rpOpenInNewWindow,
      currentPageId : rpCurrentPageId,
      currentEventId : rpCurrentEventId
    });
  }


  this.openInsertLinkDialog = (pButton) =>
  {
    let dParams,
        contentStyles;

    pEditor.pDialog = pButton.getDialog();

    dParams = prepareInsertLinkDialog(pButton);

    if (dParams.isCommandValid)
    {
      pEditor.range.save();

      if (dParams.title.replace(/[\n\r]+/g, '').replace(/(<[\/\!]?[A-Za-z0-9-]+.*?>|(&nbsp;|\s)+)/ig, '') === '')
      {
        dParams.title = '';
      }

      if (pEditor.pParent.getContentStyles)
      {
        contentStyles = pEditor.pParent.getContentStyles();
      }

      if (!contentStyles)
      {
        contentStyles = BEditor.Config.getThemeStyles();
      }

      const params =
      {
        title: dParams.title,
        imageLink: dParams.imageLink,
        imageWidth: dParams.imageWidth,
        imageHeight: dParams.imageHeight,
        imageBorder: dParams.imageBorder,
        imageAlign: dParams.imageAlign,
        imageTitle: dParams.imageTitle,
        imageAlt: dParams.imageAlt,
        imageStyle: dParams.imageStyle,
        link: dParams.link,
        tooltip: dParams.tooltip,
        linkStyle: dParams.className,
        isStyleLink: dParams.isStyleLink,
        openInNewWindow: dParams.openInNewWindow,
        currentPageId: dParams.currentPageId,
        currentEventId: dParams.currentEventId,
        isEmptyTitle: ((!dParams.title && !dParams.imageLink)),
        isSimpleView: WA && WA.PageView && !WA.PageView.isAdminView,
        isEditEmail: (window.EditorToolbarComposeEmailConfig && pEditor.pToolbarConfig.name === EditorToolbarComposeEmailConfig.name),
        layoutId: (pEditor.pThis.getLayoutId ? pEditor.pThis.getLayoutId() : null),
        isHideLinkButton: (!(!pEditor.pThis.getIsBlankTemplate || !pEditor.pThis.getIsBlankTemplate())),
        styleClassName: (contentStyles ? contentStyles.cssClasses : null),
        styleNames: (contentStyles ? contentStyles.linkStyles : null),
        isSlideShowGadgetSettings: false,
        isEditMode: !!dParams.link,
        isLinkTextEditable: !dParams.title
      };

      window.BEditor.openDialog('openInsertLinkDialog', function(params) { pEditor.pThis.execCommand(pButton, 'insertLink', params); },  function() { pEditor.afterCloseDialog(); }, params );

      pEditor.afterOpenDialog();
    }
  };


  this.insertLink = (pButton, args) =>
  {
    var linkTagBegin = '';
    var linkTag = '';
    var linkTagEnd = '';
    var linkId = 'idLink_' + (new Date()).getTime();
    var linkElement;
    var currentRangeText;
    var currentRangeHTML;
    var currentControlElement;
    var element;
    var parentElement;
    var imageObject;
    var pParameters, currentSelection, currentRange;
    var currentRangeEnd;
    var rangeElement;
    var parentCurrentElement;
    var checkParentTagA = /^a$/i;
    var checkFirstBlockTags = /^<(body|p|h[1-6]|div|pre|li|blockquote|center|dt|dd|td|th|address|marquee)(\s|>)/i;
    var endSpace = '';
    var isAbsElement = false;

    // if (pEditor.pDialog)
    // TODO:Dime Remove after all checks
    if (true)
    {
      pParameters = (args ? args : pEditor.pDialog.getReturnedParameters());

      if(pEditor.docum.insert.isDocumentDialogOpen)
      {
        pEditor.docum.insert.isDocumentDialogOpen = false;
      }

      pEditor.afterCloseDialog();

      if (pParameters)
      {
        if (pParameters.link)
        {
          linkTagBegin += '<a ' + (!(BEditor.browser.isIE && BEditor.browser.isIE < 10) ? 'data-watmpid="' + linkId + '" ' : '') + 'href="' + pParameters.link + '"';
          linkTagBegin += ((BEditor.browser.isIE && BEditor.browser.isIE < 10) && pParameters.link.indexOf('#') === 0) ? ' data-anchorhref="' + pParameters.link + '"' : '';
          linkTagBegin += (pParameters.tooltip) ? ' title="' + pParameters.tooltip + '"' : '';
          linkTagBegin += ((pParameters.openInNewWindow) ? ' target="_blank"' : '');
          linkTagBegin += ((pParameters.linkStyle) ? ' class="' + pParameters.linkStyle + '"' : '');

          if (pEditor.isEditorInHeader && pParameters.isEmptyTitle)
          {
            rangeElement = pEditor.layer.helpers.isRangeElementPositionAbsolute();

            if (!rangeElement)
            {
              linkTagBegin += ' style="position: absolute; left: 17px; top: 17px; z-index: ' + (pEditor.layer.coAbsElementZIndex++) + '"';
              isAbsElement = true;
            }
          }

          linkTagBegin += '>';
        }
        else
        {
          pLink.remover.removeLink();
          return;
        }

        if (pParameters.imageLink)
        {
          linkTag += '<img src="' + pParameters.imageLink + '"';
          linkTag += (pParameters.imageWidth) ? ' width="' + pParameters.imageWidth + '"' : '';
          linkTag += (pParameters.imageHeight) ? ' height="' + pParameters.imageHeight + '"' : '';
          linkTag += (pParameters.imageBorder) ? ' border="' + pParameters.imageBorder + '"' : '';
          linkTag += (pParameters.imageAlign) ? ' align="' + pParameters.imageAlign + '"' : '';
          linkTag += (pParameters.imageTitle && !pParameters.tooltip) ? ' title="' + pParameters.imageTitle + '"' : '';
          linkTag += (pParameters.tooltip) ? ' alt="' + pParameters.tooltip + '"' : ' alt="' + pParameters.imageAlt + '"';
          linkTag += (pParameters.imageStyle) ? ' style="' + pParameters.imageStyle + '"' : '';
          linkTag += '>';
        }
        else
        {
          if (pParameters.title)
          {
            linkTag = pParameters.title;
          }
          else
          {
            linkTag = (pParameters.link.indexOf('#') === 0) ? pParameters.link.substr(1) : (pParameters.link.indexOf('/#') === 0) ? pParameters.link.substr(2) : pParameters.link;
          }
        }

        if (pParameters.link)
        {
          linkTagEnd += '</a>';
        }
      }
      else
      {
        pLink.remover.removeLink();
      }

      if (linkTag)
      {
        currentRange = pEditor.range.getCurrent(true);
        currentSelection = pEditor.range.selection.getCurrent(true);
        if (currentRange || pEditor.image.currentImage)
        {
          if (BEditor.browser.isIE && BEditor.browser.isIE < 10)
          {
            currentControlElement = (currentSelection.type.toUpperCase() === 'CONTROL' && currentRange) ? currentRange.item(0) : (pEditor.image.currentImage ? pEditor.image.currentImage : null);

            if (currentControlElement)
            {
              parentElement = currentControlElement.parentNode;
              currentControlElement.outerHTML = linkTagBegin + linkTag.replace(/<img/i, '<img data-watempmarker="1"') + linkTagEnd;
              element = parentElement.querySelector('[data-watempmarker]');

              if (element)
              {
                element.removeAttribute('data-watempmarker');
                pEditor.image.currentImage = element;
              }
            }
            else
            {
              parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, pEditor.checkAllBlockTags);
              currentRangeText = parentCurrentElement.innerText;
              currentRangeHTML = currentRange.htmlText.replace(/[\r\n]/g, '');
              checkFirstBlockTags.lastIndex = 0;

              if (checkFirstBlockTags.test(currentRangeHTML))
              {
                if (currentRangeText)
                {
                  parentCurrentElement.innerHTML = linkTagBegin + linkTag + linkTagEnd;
                }
                else
                {
                  currentRange.pasteHTML(linkTagBegin + linkTag + linkTagEnd);
                }
              }
              else
              {
                parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

                if (parentCurrentElement)
                {
                  parentCurrentElement.outerHTML = linkTagBegin + linkTag + linkTagEnd;
                  currentRange.select();
                }
                else
                {
                  currentRangeEnd = currentRange.duplicate();
                  currentRangeEnd.moveEnd('character', 1);
                  currentRangeEnd.collapse(false);
                  currentRangeEnd.moveStart('character', -1);

                  if (currentRangeEnd.text === ' ')
                  {
                    currentRange.moveEnd('character', 1);
                    endSpace = ' ';
                  }

                  currentRange.select();
                  currentRange.pasteHTML('');
                  currentRange.moveStart('character', 1);
                  currentRange.moveStart('character', -1);
                  currentRange.collapse(true);
                  currentRange.pasteHTML(linkTagBegin + linkTag + linkTagEnd + endSpace);

                  if (endSpace === ' ')
                  {
                    currentRange.moveStart('character', -1);
                    currentRange.collapse(true);
                    currentRange.select();
                  }
                }
              }
            }

            if (pParameters.imageLink)
            {
              pEditor.image.objectFactory.checkAllImages();

              if (pEditor.image.currentImage)
              {
                imageObject = pEditor.image.objectFactory.getImageObject(pEditor.image.currentImage);

                if (imageObject)
                {
                  imageObject.object.select(true);
                }
              }
            }
          }
          else
          {
            if (pEditor.image.currentImage)
            {
              linkElement = pEditor.iFrameDoc.createElement('A');
              pEditor.image.currentImage.parentNode.insertBefore(linkElement, pEditor.image.currentImage);
              linkElement.outerHTML = linkTagBegin + linkTagEnd;
              linkElement = pEditor.iFrameDoc.body.querySelector('A[data-watmpid="' + linkId + '"]');
              linkElement.appendChild(pEditor.image.currentImage);
              pEditor.layer.objectFactory.selectNewElement(pEditor.image.currentImage);
            }
            else
            {
              if (BEditor.browser.isWebKit)
              {
                parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, checkParentTagA, pEditor.checkAllBlockTags);

                if (parentCurrentElement)
                {
                  currentSelection.removeAllRanges();
                  currentRange = pEditor.iFrameDoc.createRange();
                  currentRange.selectNode(parentCurrentElement);
                  currentSelection.addRange(currentRange);
                }
              }

              parentCurrentElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, /^p$/i);

              if (parentCurrentElement && parentCurrentElement.innerHTML === linkTag)
              {
                parentCurrentElement.innerHTML = linkTagBegin + linkTag + linkTagEnd;
              }
              else
              {
                currentRange.deleteContents();
                pEditor.contentCleaner.removeEmptyP();
                currentRange.insertNode(currentRange.createContextualFragment(linkTagBegin + linkTag + linkTagEnd));
              }

              linkElement = pEditor.iFrameDoc.body.querySelector('A[data-watmpid="' + linkId + '"]');

              if (linkElement)
              {
                currentSelection.removeAllRanges();
                currentRange = pEditor.iFrameDoc.createRange();
                currentRange.selectNode(linkElement);
                currentRange.selectNode(linkElement);
                currentSelection.addRange(currentRange);
              }

              if (isAbsElement)
              {
                pEditor.layer.objectFactory.fixAllAbsElements(true);
              }
            }

            if (linkElement)
            {
              linkElement.removeAttribute('data-watmpid');
            }
          }

          pEditor.range.save();
        }
      }
    }
  };


  this.prepareInsertLinkDialog = prepareInsertLinkDialog;
}